export default __webpack_public_path__ + "static/media/vuesax-linear-clock.03e1698e.svg";